import React, { useEffect } from 'react';
import Toast from '../ui/Toast';
import { zIndex } from '../../design-system/tokens';

/** Minimal toast — errors, success, critical only. */
export default function AppToast({ toast, onDismiss }) {
  useEffect(() => {
    if (!toast) return undefined;
    const t = setTimeout(() => onDismiss?.(), toast.durationMs ?? 4500);
    return () => clearTimeout(t);
  }, [toast, onDismiss]);

  if (!toast?.message) return null;

  return (
    <div
      className="fixed bottom-6 left-1/2 -translate-x-1/2 w-[min(24rem,calc(100vw-2rem))]"
      style={{ zIndex: zIndex.toast }}
    >
      <Toast
        message={toast.message}
        title={toast.title}
        variant={toast.variant || 'error'}
      />
    </div>
  );
}
